<template>
  <div :class="badgeClasses">
    <span v-if="hasIcon" class="tagIcon"></span>
    <span v-if="labelComputed">{{ labelComputed }}</span>
  </div>
</template>

<script>
import tagsConfig from 'marketplace-front-core/config/tags'

export default {
  name: 'OptionTagBadge',
  props: {
    color: {
      type: String,
      default: ''
    },
    hasIcon: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small', // 'small' | 'large'
      validator: v => ['small', 'large'].includes(v)
    }
  },
  data () {
    return {
      availableTagColors: tagsConfig.colors || []
    }
  },
  computed: {
    labelComputed () {
      return this.label && this.label.trim() ? this.label.trim() : ''
    },
    sizeClass () {
      return this.size === 'large' ? 'is-large' : 'is-small'
    },
    colorClass () {
      if (!this.color) return ''
      const colorConfig = this.availableTagColors.find(c => c.value === this.color)
      if (colorConfig) {
        return `option-tag-${colorConfig.value}`
      }
      return `option-tag-${this.color.toLowerCase()}`
    },
    badgeClasses () {
      return [
        'option-tag-badge',
        this.sizeClass,
        this.colorClass,
        { 'icon-only-tag': this.hasIcon && !this.labelComputed }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.option-tag-badge {
  display: inline-flex ;
  align-items: center ;
  justify-content: center ;
  border-radius: 20px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 2px solid;
  border-color: transparent;
  white-space: nowrap;
  overflow: hidden;

  &.is-small {
    min-width: 31px ;
    height: 18px ;
    font-size: 10px ;
    padding: 2px 4px;
  }

  &.is-large {
    min-width: 36px ;
    height: 20px ;
    font-size: 12px ;
    padding: 6px 4px;
  }

  &:hover {
    box-shadow: none !important;
  }

  span.tagIcon {
    padding-left: 10px !important;
  }

  &:not(.icon-only-tag):not(:has(span.tagIcon)) {
    justify-content: center !important;
    text-align: center !important;
  }

  &.icon-only-tag {
    width: auto !important;
    flex-shrink: 0 !important;
    padding: 2px !important;
    min-width: 14px !important;
    height: 14px !important;
    justify-content: center !important;
    align-items: center !important;
    border-radius: 12px !important;

    span.tagIcon {
      padding: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 12px !important;
      height: 12px !important;

      &::before {
        position: static !important;
        width: 8px !important;
        height: 8px !important;
      }
    }
  }
}
</style>


